import React, { useEffect, useState } from 'react'
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton'
import { useTranslation } from '../../locale/useTranslation'
import moment from 'moment';
import SalesDashboardTile from '../Dashboard/SalesDashboardTile';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import PieCharts from '../Dashboard/Charts/PieChart';
import * as API from "../../../src/framework/API/api";
import InsightCard from './InsightCard';
import { TextWithIconCell } from '../../framework/forms/helpercomponents/CustomGridCells/TextWithIconCell';
import PublishOrUnPublishStatusCard from './PublishOrUnPublishStatusCard';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';

const SMDashboard = () => {

    const lang = useTranslation();
    const today = moment();

    const blankDataItem = {
        FromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        ToDate: today.format('YYYY-MM-DD')
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [dashboardata, setDashboardata] = useState({});
    const [upcomingCampaignData, setUpcomingCampaignData] = useState([]);
    const [budgetCardsData, setBudgetCardsData] = useState([]);

    useEffect(() => {
        loadDashboardData();
    }, []);

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    };

    const loadDashboardData = async () => {
        let res = await API.getDashboard(moment(dataItem?.FromDate).valueOf(), moment(dataItem?.ToDate).valueOf());
        if (res?.success) {
            console.log(res?.data);
            setDashboardata(res?.data?.response);
            setUpcomingCampaignData(res?.data?.upcomingCampaigns);
            setGridData(res?.data?.response?.campaignAnalytics || []);
            setBudgetCardsData(res?.data?.budgetCards);
        } else {
            console.error("Dashboard data is empty or undefined", res);
        }
    };
    const tileData = dashboardata
        ? [
            { color: "#4caf50", count: dashboardata?.totalBudget, icon: "fa-solid fa-wallet", status: lang.total_budget_label, route: "/home/smBudgets" },
            { color: "#FF69B3", count: dashboardata?.CampaignsActive, icon: "fa-solid fa-bullhorn", status: lang.campaign_active_label, route: "/home/smCampaign" },
            { color: "#ff9800", count: dashboardata?.CampaignsInActive, icon: "fa-solid fa-circle-xmark", status: lang.campaign_inactive_label, route: "/home/smCampaign" },
            { color: "#00acc1", count: dashboardata?.publishAds, icon: "fa-solid fa-check-circle", status: lang.publish_ads_label, route: "/home/smBudgets" },
            { color: "#9c27b0", count: dashboardata?.unpublishAds, icon: "fa-solid fa-clock", status: lang.unpublish_ads_label, route: "/home/smBudgets" }
        ]
        : [];

    const InsightData = [
        { label: "Impressions", value: dashboardata?.campaignInsight?.impressions || 0 },
        { label: "Clicks", value: dashboardata?.campaignInsight?.clicks || 0 },
        { label: "Spend", value: dashboardata?.campaignInsight?.spend || 0 },
        { label: "CPC", value: `${dashboardata?.campaignInsight?.cpc || 0}` },
        { label: "CPM", value: `${dashboardata?.campaignInsight?.cpm || 0}` },
        { label: "CTR", value: `${dashboardata?.campaignInsight?.ctr || 0}%` },
    ]

    const budgetCards = budgetCardsData?.length > 0 ? budgetCardsData.map((x) => {
        const getIconAndColor = () => {
            const normalizedId = x._id?.trim()?.toLowerCase().replace(/\s+/g, "");
            switch (normalizedId) {
                case "total":
                    return { icon: <i className="fa fa-wallet text-white" style={{ fontSize: "38px" }}></i>, color: "bg-primary" };
                case "consumed":
                    return { icon: <i className="fa fa-fire text-white" style={{ fontSize: "38px" }}></i>, color: "bg-danger" };
                case "balance":
                    return { icon: <i className="fa fa-balance-scale text-white" style={{ fontSize: "38px" }}></i>, color: "bg-success" };
                default:
                    return { icon: <i className="fa fa-question-circle text-white" style={{ fontSize: "38px" }}></i>, color: "bg-secondary" };
            }
        };
        const { icon, color } = getIconAndColor();
        return {
            title: x._id,
            count: x.count,
            totalCount: x.totalCount,
            icon,
            color,
        };
    }) : [];


    return (
        <>
            <div className="page-title txt-color-bludeDark mb-0">
                <i
                    className="fa fa-table marlr"
                    style={{ fontSize: "20px", color: "GrayText" }}
                ></i>
                <span>{lang.social_media_dashboard_page_breadcrumb}</span>
            </div>
            <div className="d-flex justify-content-between align-items-end shadow-sm bg-gray-light rounded p-3 flex-wrap">
                {/* Left Section */}
                <div className="d-flex align-items-end gap-3 flex-wrap">
                    <div>
                        <label htmlFor="FromDate" className="form-label">{lang.from_date_label} *</label>
                        <input
                            className="form-control form-control-sm"
                            style={{ width: "175px" }}
                            name="FromDate"
                            type="date"
                            value={dataItem.FromDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className='ml-3'>
                        <label htmlFor="ToDate" className="form-label">{lang.to_date_label} *</label>
                        <input
                            className="form-control form-control-sm"
                            style={{ width: "175px" }}
                            name="ToDate"
                            type="date"
                            value={dataItem.ToDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="pt-2">
                        <ActionButton name={lang.show_button_text} onClick={loadDashboardData} />
                    </div>
                </div>

                {/* Right Section */}
                <div className="text-end mt-2 mt-md-0">
                    <span className="salesDashboard_title">Available Budget</span><br />
                    <span className="salesDashboard_Count ml-2">{dashboardata?.availableBudget ?? 0}</span>
                </div>
            </div>
            <div className='mt-2 fw-bold'>{lang.campaign_label}</div>
            <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding: "10px", scrollbarWidth: "none", }}>
                <div style={{ display: "inline-flex", gap: "10px" }}>
                    {tileData.map((tile, idx) => (
                        <div key={idx} className="salesDashboard_forCard" style={{ minWidth: "290px" }}>
                            <SalesDashboardTile
                                iconBackColor={tile?.color}
                                count={`${tile?.count || 0}`}
                                icon={tile?.icon}
                                status={tile?.status}
                                description={lang.view_details_label}
                                route={tile?.route}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className='mb-2 fw-bold' style={{ marginTop: "-14px" }}>{lang.campaign_insights_label}</div>
            <div className='mb-4'><InsightCard data={InsightData} /></div>
            {budgetCards?.length > 0 && <>
                <div className='fw-bold'>{lang.budget_label}</div>
                <div className="d-flex gap-4 mb-2 overflow-auto" style={{ scrollbarWidth: "none" }}>
                    {budgetCards.map((item, index) => (
                        <div
                            key={index}
                            className="card flex-shrink-0 shadow-sm border p-3"
                            style={{ minWidth: "300px", borderRadius: "15px", marginRight: "12px", transition: "box-shadow 0.3s" }}
                            onMouseEnter={(e) => e.currentTarget.classList.add("shadow")}
                            onMouseLeave={(e) => e.currentTarget.classList.remove("shadow")}
                        >
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <div className={`d-flex align-items-center justify-content-center rounded ${item.color}`}
                                    style={{ width: "60px", height: "60px" }}>
                                    {item.icon}
                                </div>
                                <div className="text-end ms-3">
                                    <p className="mb-1 fw-large text-dark" style={{ fontSize: "18px" }}>{item.title}</p>
                                    <p className="h4 fw-bold text-primary mb-1" >{item.count}</p>
                                    {/* <p className="mb-0 text-primary" style={{ fontSize: "15px" }}>Total : {item.totalCount}</p> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>}
            <div className='row g-4'>
                <div className="col-6">
                    <div className="card shadow-sm p-3 mb-3 bg-white rounded h-100">
                        <h2>{lang.channel_label}</h2>
                        <ul className="list-group">
                            {dashboardata?.channels?.map((channel, index) => (
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <i className={`mr-2 me-2 ${channel?.icon}`}></i>
                                        {channel?.title}
                                    </div>
                                    <span className={`badge text-white d-flex align-items-center justify-content-center ${channel?.status === "ACTIVE" ? "bg-primary " : "bg-warning"}`} style={{ width: "150px", height: "28px" }}>
                                        {channel?.status}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="col-6">
                    <div className="card p-3 shadow-sm h-100">
                        <div
                            className="dashboard-title-style d-flex justify-content-center align-items-center"
                            style={{ fontSize: '15px' }}
                        >
                            {lang.campaign_label}
                        </div>
                        <Grid data={gridData} resizable={true}>
                            <Column field="title" title={lang.name_column} width={150} />
                            <Column field="status" title={lang.status_column} width={100} />
                            <Column field="budget" title={lang.budget_column} width={100} />
                            <Column field="spent" title={lang.spent_column} width={100} />
                            <Column field="objective" title={lang.objective_column} width={100} />
                            <Column field="buyingType" title={lang.buying_type_column} width={100} />
                            <Column field="spendCap" title={lang.spend_cap_column} width={100} />
                            <Column field="specialAdCategories" title={lang.special_ad_categories_label} width={100} />
                            <Column field="bidStrategy" title={lang.bid_strategy_column} width={100} />
                            <Column field="skadnetworkAttribution" title={lang.skednetwork_attribution_column} width={100} />
                            <Column field="splitTestVariable" title={lang.split_test_variable_column} width={100} />
                            <Column field="channel" title={lang.channel_column} width={100} />
                            <Column field="cpc" title={lang.cpc_column} width={100} />
                            <Column field="cpm" title={lang.cpm_column} width={100} />
                            <Column field="ctr" title={lang.ctr_column} width={100} />
                        </Grid>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-6">
                    <PieCharts title="Agency Wise Revenue" listData={dashboardata?.agencyWiseRevenue || []} />
                </div>
                <div className="col-6">
                    <PieCharts title="Client Wise Revenue" listData={dashboardata?.clientWiseRevenue || []} />
                </div>
            </div>
            <div className='row mb-5'>
                <div className='ml-4 fs-lg fw-bold'>{lang.upcoming_campaigns_label}</div>
                <div className="col-12">
                    <Grid resizable style={{ height: "25vh", marginTop: "5px" }} data={upcomingCampaignData}>
                        <Column field='channel.adType' cell={TextWithIconCell} width="120px" title={lang.channel_column} />
                        <Column field='name' width="120px" title={lang.campaign_column} />
                        <Column field='start_time' width="180px" title={lang.start_time_column} cell={DateTimeCell} />
                        <Column field='end_time' width="180px" title={lang.end_time_column} cell={DateTimeCell} />
                        <Column field="status" title="Status" width="120px" cell={PublishOrUnPublishStatusCard} />
                        <Column field='budget.description' width="130px" title={lang.budget_column} />
                        <Column field='meta.objective' width="130px" title={lang.objective_column} />
                        <Column field='meta.buying_type' width="130px" title={lang.buying_type_column} />
                        <Column field='meta.bid_strategy' width="130px" title={lang.bid_strategy_column} />
                        <Column field='meta.spend_cap' width="130px" title={lang.spend_cap_column} />
                        <Column field='meta.daily_budget' width="130px" title={lang.daily_budget_column} />
                        <Column field='meta.special_ad_categories' width="130px" title={lang.special_ad_categories_label} />
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default SMDashboard